import { Zap, Wifi, Tv, ShieldCheck, Smartphone, Flame, CreditCard, HeartPulse } from "lucide-react";
import { useT } from "@/lib/i18n";

const services = [
    { Icon: Zap, titleKey: "Electricity", blurb: "Competitive plans for home and business.", primary: true },
    { Icon: Wifi, titleKey: "Internet", blurb: "High-speed for work, school, and streaming." },
    { Icon: Tv, titleKey: "TV / Cable", blurb: "Your favorite channels in one place." },
    { Icon: ShieldCheck, titleKey: "Home Security", blurb: "Cameras and smart-home peace of mind." },
    { Icon: Smartphone, titleKey: "Mobile Phone", blurb: "Flexible plans to keep you connected." },
    { Icon: Flame, titleKey: "Natural Gas", blurb: "Dependable service for home or business." },
    { Icon: CreditCard, titleKey: "Payment Processing", blurb: "Easy and secure for your business." },
    { Icon: HeartPulse, titleKey: "Healthcare", blurb: "Affordable options for your family." },
];

export default function EssentialServices() {
    const { t } = useT();
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="essential-services">
            <div className="flex items-end justify-between flex-wrap gap-4">
                <div>
                    <span className="chip">{t("es_chip")}</span>
                    <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
                        {t("es_title_a")} <span className="accent-gradient-text">{t("es_title_b")}</span>
                    </h2>
                    <p className="text-slate-400 mt-2 max-w-2xl text-sm sm:text-base">{t("es_sub")}</p>
                </div>
            </div>
            <div className="mt-8 grid gap-3 sm:gap-4 grid-cols-2 lg:grid-cols-4">
                {services.map((s, i) => (
                    <div
                        key={s.titleKey}
                        data-testid={`service-${s.titleKey.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="card-surface p-4 sm:p-5 reveal"
                        style={{ animationDelay: `${i * 50}ms` }}
                    >
                        <span className={`inline-flex items-center justify-center w-10 h-10 rounded-xl ${s.primary ? "bg-emerald-500/20 border border-emerald-500/40 text-emerald-300" : "bg-white/5 border border-white/10 text-emerald-200"}`}>
                            <s.Icon className="w-5 h-5" />
                        </span>
                        <h3 className="mt-3 text-base sm:text-lg font-semibold text-white">{s.titleKey}</h3>
                        <p className="mt-1 text-xs sm:text-sm text-slate-400 leading-relaxed">{s.blurb}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
